/**
 * Gets the units criticality, according to the site-level-mapping (defaulting to 5 if not found)
 *
 * AOE: if the siteLevelCriticalityMapping doesn't exist or unitCriticality isn't in the map, should we default to 5?
 */
export function getMappedCriticality(
  unitCriticality: string | undefined,
  siteLevelCriticalityMapping: Record<string, string> | undefined
) {
  // if criticality is undefined or doesn't fall into the mapping then default to the highest criticality
  return siteLevelCriticalityMapping?.[unitCriticality ?? '5'] ?? '5'
}
